module.exports = __webpack_public_path__ + "static/get-start-386535225121648c8d363b413af19241.png";